
import { benefits } from "~/data/privateCloud";

export default {
  data() {
    return {
      items: benefits,
    };
  },
};
